import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconFormatSizeStyle0 = gravityIconIndividualCss;

const GravityIconFormatSize = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '487f18e7fa388e2efefe0353f8ea7b2017027d9d', color: this.color, size: this.size }, h("svg", { key: '527307ecc2e4ed9fdbd2997ae8108d7ff0a32255', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: 'cae180779233e3bfc8d0332ec1f6bffbba91fab6', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M8 5v-.48A.5.5 0 0 1 8.5 4h11a.5.5 0 0 1 .5.5V5a.5.5 0 0 1-.5.5h-4.75v12a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5v-12H8.5A.5.5 0 0 1 8 5Zm-2.75 6.51H2.5A.5.5 0 0 1 2 11v-.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.51H6.75v6a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5v-6Z", fill: "currentColor" }))));
    }
};
GravityIconFormatSize.style = GravityIconFormatSizeStyle0;

export { GravityIconFormatSize as gravity_icon_format_size };

//# sourceMappingURL=gravity-icon-format-size.entry.js.map